export default __webpack_public_path__ + "static/media/a graduate.dfbb0e6d.jpg";